(function() {
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
  script.onload = function() {
    particlesJS('snow-container', {
      particles: {
        number: { value: 160, density: { enable: true, value_area: 900 } },
        color: { value: '#ffffff' },
        shape: { type: 'circle' },
        opacity: { value: 1, random: true },
        size: { value: 2, random: true },
        line_linked: { enable: false },
        move: {
          enable: true,
          speed: 1.5,
          direction: 'bottom',
          random: true,
          straight: false,
          out_mode: 'out'
        }
      },
      interactivity: {
        detect_on: 'canvas',
        events: {
          onhover: { enable: false },
          onclick: { enable: false },
          resize: true
        }
      },
      retina_detect: true
    });
  };
  document.head.appendChild(script);
})();
